
import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import FdfMasterDataCont from './FdfMasterDataCont';

const FdfMasterData = () => {
    document.title = "Master Data";
    const [isAddModalOpen, setAddModalOpen] = useState(false);
    
    const [newUser, setNewUser] = useState({
        // name: "",
        firstName: '',
        lastName: '',
        email: "",
        password: "",
        role: "",
      });
    const closeModal = () => {
        setAddModalOpen(false);
        setNewUser({
            // name: "",
            firstName: '',
            lastName: '',
            email: "",
            password: "",
            role: "",
        });    
    };

    const openAddModal = () => {
        setAddModalOpen(true);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                {/* <CardHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h2 className="card-title mb-0">Master Data</h2>
                                </CardHeader> */}
                                <CardBody>
                                    <FdfMasterDataCont
                                        isAddModalOpen={isAddModalOpen}
                                        closeModal={closeModal}
                                        setAddModalOpen={setAddModalOpen}
                                         />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default FdfMasterData;